import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requireRole = null }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <div className="text-sm text-slate-500">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  // Allow /role-select to render even without a role (it IS the role picker).
  if (!user.role && loc.pathname !== "/role-select") {
    return <Navigate to="/role-select" replace />;
  }
  if (requireRole && user.role && user.role !== requireRole && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
